/*
 * @format
 */

// The relying party the API makes passkeys for: the web app's host, which the
// build names (`yarn setup-env-file`), as passkeys are shared between the web
// app and the apps. Null where the environment's web app has no domain of its
// own ('none'), which has no passkeys either. Apart from ./passkeys, which has
// no dependencies, as this reads the generated env.

import config from '../env';

export function passkeyRpId() {
  const host = config.darwin_halo_host_name;
  return typeof host === 'string' && host && host !== 'none' ? host : null;
}
